// extracted by mini-css-extract-plugin
export default {"error-message":"TextEditor_error-message__EgRAN","editor-container":"TextEditor_editor-container__wYcCm"};